import { type Location } from '@aikoa/common'

export function toLocationKey(loc: Partial<Location>) {
  const coords = loc.coordinates
  const label = loc.label
  const postalCode = loc.postalCode
  const discriminator = loc.discriminator

  if (label && (postalCode || discriminator)) {
    return `${label.toLowerCase()}:${postalCode ?? discriminator ?? ''}`
  }

  if (coords) {
    return `${label?.toLowerCase()}:${coords.lat.toFixed(5)},${coords.lng.toFixed(5)}`
  }

  // Id and providerId are for server-side coordinate lookups, and do
  // not necessarily uniquely identify a location. Use as fallbacks.
  return loc.id ?? loc?.metadata?.providerId ?? '<NO-ID-FOUND>'
}
